module.exports = __webpack_public_path__ + "img/JP.f91377a5.svg";